import { SectionName } from 'types/types'

export type AdminMenuUiState = {
  collapsedBlocks: SectionName[]
  needToSaveBlock: SectionName | ''
  isModalVisible: boolean
  navbarColor: string
}

export const initialAdminMenuUiState: AdminMenuUiState = {
  collapsedBlocks: [],
  needToSaveBlock: '',
  isModalVisible: false,
  navbarColor: '',
}
